export default {
  hi_im_neela: 'Здравствуйте, я Нила, ',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: 'виртуальный ассистент компании Aareon.',
  media: 'Медиа',
  media_link: 'https://neela.aareon.de/media',
  contact: 'Контакт',
  contact_link: 'https://neela.aareon.de/contact',
  privacy: 'Защита данных',
  privacy_link: 'https://www.aareon.de/sixcms/detail.php/46076',
  terms_of_use: 'Условия использования',
  terms_of_use_link:
    'https://www.aareon.com/Allgemeine_Informationen/Nutzungsbedingungen.2366.html',
  legal_notice: 'служе́бная информа́ция',
  legal_notice_link: 'https://neela.aareon.de/legal',
  show_system_messages: 'Отображение системных сообщений',
  dont_show_system_messages: 'Скрытие системных сообщений',
  logged_in: 'Арендатор аутентифицирован',
  logged_out: 'Анонимный пользователь',
  button_switch_locale: 'Сменить язык',
  button_tooltip_activate_voice_recognition: 'Активируйте распознавание речи',
  date_input: 'Выберите дату',
  choose_two_dates: 'Пожалуйста, выберите две даты',
  date_range: 'Диапазон дат',
  from: 'с сайта',
  to: 'на',
  avatar: 'Аватар',
  exit: 'Конец',
  new: 'Новый',
  back: 'Назад',
  suggestions: 'Предложения',
  senton: 'Oтправлено',
  message_placeholder: 'Введите сообщение здесь',
  comment_placeholder: 'Введите комментарий здесь',
  file_max_upload_text: 'Можно загрузить не более 20 файлов',
  message_button_label: 'Отправить',
  please_confirm: 'Пожалуйста, подтвердите',
  no: 'Нет',
  yes: 'Да',
  modal_delete_session: 'Удалить эту сессию',
  modal_delete_session_notification:
    'Когда вы закроете окно, ваша сессия также будет удалена.<br> Вы согласны?',
  template_contact_time: 'Когда мы можем связаться с вами?',
  template_pause:
    'Ваша сессия была приостановлена. Один из наших сотрудников службы поддержки рассмотрит ваш запрос в ближайшее время.',
  template_continue_after_pause:
    'Ваша сессия была возобновлена. Теперь вы можете продолжить переписку с нашим чатботом.',
  button_apply: 'Принять',
  button_cancel: 'Cноси́ть',
  none: 'никто́',
  book_appointment: 'Заказать прием',
  address_input: 'Адресный вход',
  data_processing: 'Обработка данных',
  privacy_policy: 'политику конфиденциальности.',
  data_processing_notification_before_link:
    'Для того чтобы пользоваться услугами этого чата, необходимо, чтобы вы ',
  data_processing_notification_after_link: 'приняли',
  button_accept: 'Принять',
  select_date: 'выберите дату',
  rate_conversation: 'Как бы вы оценили этот разговор',
  new_ticket_question: 'Могу ли я сделать для вас что-нибудь еще?',
  thank_you:
    'Спасибо за вашу поддержку. Ваши отзывы помогают мне постоянно совершенствоваться',
  goodbye: 'До скорого',
  start_new: 'Начать новый разговор',
  operator_entered_the_chat: 'Оператор вошел в чат',
  operator_left_the_chat: 'Оператор покинул чат',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'Больше',
  collapse_quickreplies: 'Меньше',
  login: 'Вход в систему',
  logout: 'Выйти из системы',
  close: 'Закрыть',
  upload_file: 'Разместите файл для загрузки здесь',
  upload_file_or: 'или',
  upload_file_select: 'добавьте файлы здесь',
  upload_file_text: 'Drop file to upload',
  show_attachments: 'Показать вложения',
  hide_attachments: 'Скрыть вложения',
  maximize: 'максимизировать',
  minimize: 'Минимизировать',
  tooBig: 'Файл слишком большой',
  tooSmall: 'Файл слишком мал',
  feedback_helpful: 'Этот ответ помог мне',
  feedback_not_helpful: 'Этот ответ мне не помог',
  showMore: 'Показать больше',
  showLess: 'Показать меньше',
  feedbackDescription: 'Отзывы для нас',
  feedbackSubtitle: {
    description:
      'Здесь вы можете направить нам общие предложения, пожелания и просьбы.',
    note: 'Обратите внимание, что мы не можем ответить на них.',
    hint:
      'Все остальные вопросы, которые касаются конкретно вашего проживания или поиска квартиры, вы можете изложить нам в чате.'
  },
  feedbackPlaceholder: 'Введите ваше сообщение здесь...',
  sendFeedback: 'Отправить',
  giveFeedback: 'Отзывы для нас',
  feedbackSubmittedSuccessfully: 'Ваш отзыв был успешно отправлен',
  thanks: 'Спасибо'
}
